import React      from "react"
import LineBase   from "./line_base"

// Components
import Destroyed  from "./line_destroyed"
import Buttons    from "./shared/buttons"
import Combobox   from "@shared/combobox"

// Helpers
import { getRequest } from '@helpers/javascript/javascript'

export default class Group extends LineBase {
  constructor(props) {
    super(props)
    this.onSubmit = this.onSubmit.bind(this)
    this.state    = {...this.state, groupId: "", amount: 1, unit: ""}
  }

  onSubmit() {
    const { index, qline }          = this.props
    const { groupId, amount, unit } = this.state
    const { addGroup }              = this.props.groupProps
    getRequest(`/quotes/form/${groupId}/group.json?currency=${qline.currency}`)
    .then(group => addGroup(group, parseFloat(amount), unit, index))
  }

  render() {
    const { index, qline, buttonProps} = this.props
    const { groupId, amount, unit    } = this.state
    const { groups }                   = this.props.groupProps

    return(
      <div className="quotes--form-qline-container">
        <div className="text-input d-flex mb-2">
          <div className="d-flex flex-column j-c-end" style={{width: "calc(80% - 16px)"}}>
            <Combobox
              options         = {groups}
              value           = {groupId}
              display         = "title"
              onSelectElement = {group => this.setState({ groupId: group.id, unit: group.unit })}
              prompt          = {I18n.t("quotes.new.select_group")}
              required        = {true}
            />
          </div>

          <div className="w-10 ml-2 mr-2">
            <label>{I18n.t("quotes.new.quantity")}</label>
            <input
              className="form-control"
              type="number"
              step="1"
              min="0"
              onChange={e => this.setState({ amount: e.target.value })}
              value={amount}
            />
          </div>

          <div className="w-10">
            <label>{I18n.t("quotes.new.unit")}</label>
            <input
              className="form-control"
              onChange={e => this.setState({ unit: e.target.value })}
              value={unit}
            />
          </div>
        </div>

        <Buttons
          index={index}
          qline={qline}
          buttonProps={buttonProps}
          submit={groupId && amount ? this.onSubmit : null}
        />

        <Destroyed
          index={index}
          qline={qline}
        />
      </div>
    )
  }
}
